import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseForm from '../../../components/forms/CourseForm';
import { useCourseApi } from '../../../hooks/useCourseApi';
import { useNavigate } from 'react-router-dom';
import { CourseDTO } from '../../../services/apiClient';
import { getRoles } from '../../../utils/tokenUtils';

const CourseCreate: React.FC = () => {
  const { create, isLoading } = useCourseApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const roles = getRoles();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Courses', href: '/admin/dedicatedstatus' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CourseDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      handleNavigate();
    } catch (error) {
      console.error('Error creating Course:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/dedicatedstatus"
      breadcrumbs={breadcrumbs}
      allowedRoles={['User']}
      requiredPermission='Manage.Course.Edit'
    >
        <CourseForm
          initialValues={{} as CourseDTO}
          onSubmit={handleSubmit}
          onCancel={handleNavigate}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default CourseCreate;